import { get } from 'lodash';
import { type ReactElement, useState } from 'react';

import { CardListSelectController } from '../../../shared/ui/card-list';
import type { DataInterface } from './file-upload.types';
import { useFileUploadStore } from './file-upload-context';
import { mapWorkbook } from './map-workbook';

const SheetSelectionStep = ({
  ContainerElement,
}: {
  ContainerElement: ({
    onSubmit,
    children,
  }: {
    onSubmit: () => void;
    children: ReactElement;
  }) => ReactElement;
}) => {
  const sheetNames = useFileUploadStore((state) => state.sheetNames ?? []);
  const workbook = useFileUploadStore((state) => state.workbook ?? null);
  const setFileData = useFileUploadStore((state) => state.setData);
  const goToNext = useFileUploadStore((state) => state.goToNext);
  const defaultValue = get(sheetNames, '[0]', ['']);
  const [value, setValue] = useState([defaultValue]);
  const handleValueChange = (e: string[]) => {
    if (e.length === 0) {
      return;
    }
    const lastItem = e[e.length - 1];
    setValue([lastItem]);
  };

  const items = [
    {
      heading: null,
      columns: sheetNames.map((sheetName: string) => ({
        id: sheetName,
        label: sheetName,
      })),
    },
  ];

  return ContainerElement({
    onSubmit: () => {
      const mappedWorkbook = mapWorkbook(workbook, value[0]);
      setFileData((prevData: DataInterface) => ({
        ...prevData,
        mappedWorkbook,
        selectedSheet: value[0],
      }));
      goToNext();
    },
    children: (
      <CardListSelectController
        variant="columns"
        items={items}
        value={value}
        hideCtaIfNotSelected={true}
        gridProps={{
          spacing: 4,
          columns: 3,
          gridAutoFlow: 'row',
        }}
        onChange={handleValueChange}
      />
    ),
  });
};

export default SheetSelectionStep;
